import axios from 'axios';
import { API_BASE_URL } from './apiBaseUrl';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  // Don't clobber an explicit header, e.g. the fresh token verifyOtp passes to /me
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;

  const tenantId = localStorage.getItem('tenantId');
  if (tenantId) config.headers['X-Tenant-ID'] = tenantId;

  return config;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;

// Maps backend Role enum → frontend route
export function getDashboardRoute(role) {
  const routes = {
    ADMIN:   '/dashboard/super-admin',
    DOCTOR:  '/dashboard/doctor',
    PATIENT: '/dashboard/patient',
  };
  return routes[role] || '/dashboard';
}